 // mutations
 export default {
   // 更新小区列表
   updateCommunities(state, val) {
     state.communities = val
   },
   // 更新商圈
   updateBusinesses(state, val) {
     state.businesses = val
   },
   // 更新各区县
   updateCounties(state, val) {
     state.counties = val
   },
   // reaload 小区
   reloadCommunities(state) {
     var date = new Date()
     state.communityStatus = date.getTime()
   },
   // reload 商圈
   reloadBusiness(state) {
     var date = new Date()
     state.businessStatus = date.getTime()
   },
   // reload 县区
   reloadCounties(state) {
     var date = new Date()
     state.countyStatus = date.getTime()
   },
   // 更新微信状态
   updateWxReady(state, val) {
     state.wxReady = val
   }
 }



// WEBPACK FOOTER //
// ./src/store/mutations.js